import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  id: "js-project-banner",
  class: "gfu-project-banner"
}
const _hoisted_2 = { class: "gfu-project-banner__content" }
const _hoisted_3 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_4 = {
  class: "gfu-grid__cell gfu-1of1 gfu-1of6--m gfu-1of10--l",
  "data-qa": "project-banner-image"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "gfu-embed gfu-embed--1x1 gfu-thumb__item" }
const _hoisted_7 = { class: "gfu-grid__cell gfu-1of1 gfu-5of6--m gfu-9of10--l" }
const _hoisted_8 = {
  class: "gfu-project-banner__title _mb-1",
  "data-qa": "project-banner-title"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  class: "gfu-project-banner__title-annotation-text",
  "data-qa": "project-banner-creator"
}
const _hoisted_13 = {
  class: "gfu-project-banner__description",
  "data-qa": "project-banner-description"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "gfu-project-banner__content-wrapper",
      style: _normalizeStyle($options.contentWrapperStyle)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              href: $props.projectHomeUrl,
              class: "gfu-thumb _screen--none _screen--m",
              "data-qa": "project-banner-image-url"
            }, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_base_image, {
                  class: "gfu-embed__item",
                  loading: "lazy",
                  src: $props.projectImage,
                  alt: $props.projectName
                }, null, 8 /* PROPS */, ["src", "alt"])
              ])
            ], 8 /* PROPS */, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("a", {
                href: $props.projectHomeUrl,
                class: "gfu-link gfu-link--nofx",
                "data-qa": "project-banner-title-url"
              }, _toDisplayString($props.projectName), 9 /* TEXT, PROPS */, _hoisted_9)
            ]),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _createElementVNode("span", {
              class: _normalizeClass(["gfu-project-banner__title-annotation", [$props.creatorImage ? 'gfu-project-banner__title-annotation--has-image' : '']])
            }, [
              _createVNode(_component_localize, {
                resource: _ctx.Resources.ProjectHome.ProjectHeaderByCreatorTitle
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    "format-key": "0",
                    class: "gfu-link gfu-link--nofx",
                    href: $props.creatorHomeUrl,
                    "data-qa": "project-banner-creator-url"
                  }, [
                    ($props.creatorImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "gfu-embed gfu-embed--1x1 gfu-project-banner__title-annotation-image",
                          loading: "lazy",
                          src: $props.creatorImage,
                          alt: $props.creatorName
                        }, null, 8 /* PROPS */, _hoisted_11))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("span", _hoisted_12, _toDisplayString($props.creatorName), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_10)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["resource"])
            ], 2 /* CLASS */),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", null, _toDisplayString($props.projectShortDescription), 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ], 4 /* STYLE */)
  ]))
}